module.exports = __webpack_public_path__ + "img/logo-white.69d2f515.png";